module.exports = __webpack_public_path__ + "static/media/D-stats.84ef9449.png";